export default "__VITE_ASSET__DrtRqJ$6__"